import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import grey from '@material-ui/core/colors/grey';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import {MenuToggleIcon} from '../icons/index';

const styles = theme => ({
  position: 'relative',
	whiteSpace: 'nowrap',
	width: "300px",
	transition: theme.transitions.create('width', {
	  easing: theme.transitions.easing.sharp,
	  duration: theme.transitions.duration.enteringScreen,
	}),
	drawerPaper: {
		width: '300px'
	}
});

class SideBar extends React.Component {
	constructor(props) {
		super(props);

		this.state = {open:true}
	}
	
	render() {

		const { classes, theme, enabled } = this.props;

		if(typeof enabled !== 'undefined' && !enabled) {
			return null;
		}

		if(this.props.pos === 'left'){
			
			var closeIcon = (<MenuToggleIcon style={{transform: 'rotate(180deg)', margin: '0 0 0 4px'}} color={grey[900]} />);
			var openIcon = (<MenuToggleIcon color={grey[900]} style={{margin: '0 6px 0 0'}} />);
			
		} else {

			var closeIcon = (<MenuToggleIcon color={grey[900]} style={{margin: '0 4px 0 0'}}/>);
			var openIcon = (<MenuToggleIcon style={{transform: 'rotate(180deg)', margin: '0 0 0 6px'}} color={grey[900]} />);
		}
		if(this.state.open) {
			var icon = openIcon;
			var distance = (this.props.width ? this.props.width : 300) + 'px';
		} else {
			var distance = '0px';
			var icon = closeIcon;
		}
		if(this.props.pos === 'left') {
			var style = {position: 'absolute', top: 5, left: distance, zIndex:'310'};
		} else {
			var style = {position: 'absolute', top: 5, right: distance, zIndex:'310'};
		}

		return (
			<div>
				<Drawer 
					anchor={this.props.pos}
					variant="persistent"
					open={this.state.open} 
					classes={{
			            paper: classNames(classes.drawerPaper),
			          }}
			        style={{width: this.props.width + 'px'}}
					width={this.props.width}>
					{this.props.children}
				</Drawer>
				<div style={style}>
					<div
						style={{
							backgroundColor: 'rgba(255,255,255,0.8)', 
							cursor: 'Pointer',
							height: '20px',
							padding: '0 0px 4px 0px'
						}}
						onClick={() => {
				          	this.setState({open: !this.state.open}); 

				          	if(typeof this.props.toggleCallback !== 'undefined'){

				          		this.props.toggleCallback(this.state.open);
				          	}
				          }}>
					{icon}
					</div>
		        </div>
			</div>
		);
	}
}

export default withStyles(styles)(SideBar);


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/letera/src/components/sideBar/index.js